import styled from 'styled-components';
import { color, container, radius, screen, spacing } from 'theme';

export const StyledSection = styled.div`
  background-color: ${color('indigo_100')};
  padding-bottom: ${spacing('xs2')};
`;

export const StyledHighlight = styled.div`
  background-color: ${color('indigo_500')};
  padding-top: ${spacing('xl4')};
  padding-bottom: ${spacing('xl4')};
  color: ${color('text_white')};
  text-align: center;
`;

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  padding-left: ${spacing('xl')};
  padding-right: ${spacing('xl')};
`;

export const StyledList = styled.div`
  max-width: ${container('md')};
  margin: auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${spacing('xl')};
  margin-top: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const StyledItem = styled.div`
  background-color: ${color('indigo_100')};
  padding: ${spacing('mdlg')};
  text-align: left;
  border-radius: ${radius('md')};
  color: ${color('text_default')};

  span {
    display: flex;
    flex-direction: column;
    gap: ${spacing('xs')};

    &::before {
      content: '';
      width: ${spacing('xl')};
      height: ${spacing('xs2')};
      background-color: ${color('indigo_500')};
    }
  }
`;
